namespace Pages.Test._Controls.Permission {
    export async function __cdn_pages_test_controls_uservehiclesettings_onDocumentReadyAsync() {
        let main = document.querySelector('main');

        let login = new CDN.Controls.Login(main, {
            onLogin: (result) => {
                login.hide();
                
                let userInput = new CDN.Controls.UI.TextInput(main, {
                    label: 'User',
                    placeholder: 'Search',
                    autocomplete: {
                        searchAsync: async (searchTerm: string, cancellationToken: CDN.Common.CancellationToken) => {
                            let users = await CDN.API.AutoComplete.v1.searchUsersAsync({
                                userToken: result.UserToken,
                                productId: CDN.Common.ProductId.ERP,
                            }, searchTerm, cancellationToken);

                            return users.map(u => {
                                return {
                                    label: u.Username,
                                    value: u.Username,
                                    data: u,
                                };
                            });
                        },
                        onSelect: user => uservehicleManager.setUserAsync(user.Username),
                    }
                });

                let uservehicleManager = new CDN.Controls.Permission.UserVehicleSettingsManager(main, {
                    userToken: result.UserToken,
                });
            }
        });

    }
}

CDN.requireOnce([
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_Permission_User, },
    { code: CDN.PackageCode.Control_Collection, },
    { code: CDN.PackageCode.Control_Login, },
], () => {
    $(document).ready(Pages.Test._Controls.Permission.__cdn_pages_test_controls_uservehiclesettings_onDocumentReadyAsync);
});
